import { APPS_PATH } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';

export const appsRoute: GlobalHomePageRoute = createGlobalRoute({
	exact: true,
	name: 'apps',
	path: APPS_PATH,
	layout: 'home',
});
